module.exports = __webpack_public_path__ + "img/bg3.fc807011.png";